import makeStyles from '@material-ui/styles/makeStyles';
import React, { Dispatch, Reducer, ReducerAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AdvancedChecklistFilters from './AdvancedChecklistFilters';
import FiltersUI from './FiltersUI';
import SearchInput from './SearchInput';
import { AdvancedChecklistStateType } from './state/AdvancedChecklist';
import { Add } from '@material-ui/icons';
export interface IAdvancedChecklistHeader {
    selectedItemsCount: number;
    onSearchChange: (searchValue: string) => void;
    selectAll: () => void;
    selectNone: () => void;
    state: AdvancedChecklistStateType;
    dispatch: Dispatch<ReducerAction<Reducer<any, any>>>;
    onCreate?: () => void;
    headerDescription?: string;
    persistSelectedFilters?: boolean;
}

const useStyles = makeStyles({
    AdvancedChecklistHeader: {
        width: '100%',
        padding: '0 0 1.25rem 0',
        borderBottom: '1px solid #E8EAF4',
        '& >div:first-child': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& >p': {
                fontWeight: 600,
                fontSize: '0.9375rem',
                color: '#212121',
            },
            '& >div': {
                width: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& div': {
                    background: '#F3F4F9',
                    borderRadius: '56px',
                    textAlign: 'center',
                    fontSize: '0.8125rem',
                    color: '#212121',
                    padding: '5px 0.625rem',
                    margin: '0 5px',
                    '&:hover': {
                        cursor: 'pointer',
                    },
                },
            },
        },
        '& >div:nth-child(2)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& >div:first-child': {
                flex: 5,
                width: '100%',
            },
            '& >div:nth-child(2)': {
                flex: 1,
                width: '100%',
            },
        },
    },
    createNewButton: {
        height: '2.5rem',
        flex: 'auto',
        marginLeft: '0.625rem',
        '&>div': {
            border: '1px solid #C1CAE1',
            boxSizing: 'border-box',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            '&:hover': {
                cursor: 'pointer',
            },
            '&>p': {
                fontSize: '0.875rem',
                color: '#212121',
                margin: '0 0 0 5px',
            },
        },
    },
});

function AdvancedChecklistHeader(props: IAdvancedChecklistHeader) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [filtersSelected, setFiltersSelected] = useState<boolean>(false);

    const CreateNewButtonComponent = () => {
        return (
            <div className={classes.createNewButton} onClick={props.onCreate}>
                <div>
                    <Add />
                    <p>{t('forms.buttons.createNewProduct')}</p>
                </div>
            </div>
        );
    };
    return (
        <div className={classes.AdvancedChecklistHeader}>
            <div>
                <p>
                    {props.headerDescription ??
                        t(`misc.itemsSelected`, {
                            selectedCount: props.selectedItemsCount,
                        })}
                </p>
                <div>
                    <div onClick={props.selectAll}>{t('misc.selectAll')}</div>
                    <div onClick={props.selectNone}>{t('misc.selectNone')}</div>
                </div>
            </div>
            <div>
                <div>
                    <SearchInput onSearchChange={props.onSearchChange} />
                </div>
                {props.state.filtersList.length > 0 && (
                    <div onClick={() => setFiltersSelected(!filtersSelected)}>
                        <FiltersUI
                            active={filtersSelected}
                            selectedFiltersCount={props.state.selectedFiltersIDs.length}
                        />
                    </div>
                )}
                {props.onCreate && <CreateNewButtonComponent />}
            </div>
            {filtersSelected && (
                <AdvancedChecklistFilters
                    persistSelectedFilters={props.persistSelectedFilters}
                    state={props.state}
                    dispatch={props.dispatch}
                />
            )}
        </div>
    );
}

export default AdvancedChecklistHeader;
